import { CALL_API } from '../middleware/api';

export const FETCH_ADDRESSES = "FETCH_ADDRESSES";
export const SUCCESS_FETCH_ADDRESSES = "SUCCESS_FETCH_ADDRESSES";
export const FAILURE_FETCH_ADDRESSES = "FAILURE_FETCH_ADDRESSES";

export function fetchAddresses(term) {
    return {
        type: FETCH_ADDRESSES,
        [CALL_API]: {
            endpoint: `/api/address/search?term=${term}`,
            method: 'get',
            types: [SUCCESS_FETCH_ADDRESSES, FAILURE_FETCH_ADDRESSES]
        }
    }
}


// WEBPACK FOOTER //
// ./src/actions/addresses.js